export default __webpack_public_path__ + "static/media/logo-cadunico-verde-amarelo.0b33d87b.svg";